// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_WalletResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Franchise-family wallet response — NO cost fields.
 *
 * ISP: disjoint from Admin family. This class MUST NOT declare
 * provider_cost_usd / markup / raw_cost_brl / margin / fx_* fields.
 * The leak-guard (KpisContractTest) asserts their absence on every response.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_WalletResponseDados {
franquia_id: number
balance_micro: number
reserved_micro: number
balance_display: string
franchise_name: string
low_balance_threshold_micro?: number
low_balance?: boolean
}

export type AiCredits_WalletResponse = ApiResponse<AiCredits_WalletResponseDados>;

registerResponseContract('AiCredits_WalletResponse', {
  franquia_id:                 { type: 'number',  required: true },
  balance_micro:               { type: 'number',  required: true },
  reserved_micro:              { type: 'number',  required: true },
  balance_display:             { type: 'string',  required: true },
  franchise_name:              { type: 'string',  required: true },
  low_balance_threshold_micro: { type: 'number',  required: false },
  low_balance:                 { type: 'boolean', required: false },
})
